import { render, staticRenderFns } from "./collapsed-waypoints-indicator.vue?vue&type=template&id=587a1e97&scoped=true"
import script from "./collapsed-waypoints-indicator.vue?vue&type=script&lang=js"
export * from "./collapsed-waypoints-indicator.vue?vue&type=script&lang=js"
import style0 from "./collapsed-waypoints-indicator.vue?vue&type=style&index=0&id=587a1e97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587a1e97",
  null
  
)

export default component.exports